import React from "react";
import logoImage from "./../resources/logo/logo.png";
import { CaretDownOutline } from "react-ionicons";
import { CaretUpOutline } from "react-ionicons";
import satelliteImage from "./../resources/maps/satelliteMap.png";
import standardImage from "./../resources/maps/standardMap.png";
import darkImage from "./../resources/maps/darkMap.png";

export default function Header(params) {
    let toggleSettings = function () {
        params.changeStateData((ele) => {
            if (ele.headerData.onn) {
                return {
                    ...ele,
                    headerData: {
                        onn: false,
                        values: { transform: "translateY(-36vh)" },
                    },
                };
            } else {
                return {
                    ...ele,
                    headerData: {
                        onn: true,
                        values: { transform: "translateY(-1vh)" },
                    },
                };
            }
        });
    };
    let changeMap1 = function () {
        params.changeStateData((ele) => {
            return {
                ...ele,
                mapData: {
                    ...ele.mapData,
                    attribution: ele.maps[0].attribution,
                    url: ele.maps[0].url,
                },
            };
        });
    };
    let changeMap2 = function () {
        params.changeStateData((ele) => {
            return {
                ...ele,
                mapData: {
                    ...ele.mapData,
                    attribution: ele.maps[1].attribution,
                    url: ele.maps[1].url,
                },
            };
        });
    };
    let changeMap3 = function () {
        params.changeStateData((ele) => {
            return {
                ...ele,
                mapData: {
                    ...ele.mapData,
                    attribution: ele.maps[2].attribution,
                    url: ele.maps[2].url,
                },
            };
        });
    };
    let openInfo = function () {
        params.changeInfoButton("flex");
    };
    return (
        <section
            className="header"
            id="header"
            style={params.stateData.headerData.values}
        >
            <div className="header-head">
                <div className="header-head-maps">
                    <div className="maps-select" onClick={changeMap1}>
                        <div className="maps-select-header">Standard</div>
                        <div className="map-select-body">
                            <img
                                className="map-select-body-image"
                                src={standardImage}
                            ></img>
                        </div>
                    </div>
                    <div className="maps-select" onClick={changeMap2}>
                        <div className="maps-select-header">Satellite</div>
                        <div className="map-select-body">
                            <img
                                className="map-select-body-image"
                                src={satelliteImage}
                            ></img>
                        </div>
                    </div>
                    <div className="maps-select" onClick={changeMap3}>
                        <div className="maps-select-header">Dark</div>
                        <div className="map-select-body">
                            <img
                                className="map-select-body-image"
                                src={darkImage}
                            ></img>
                        </div>
                    </div>
                </div>

                <div className="logo-div">
                    <img className="logo-div-image" src={logoImage}></img>
                    <div className="info-button" onClick={openInfo}>
                        INFO
                    </div>
                </div>
            </div>
            <div className="slide-down" onClick={toggleSettings}>
                {params.stateData.headerData.onn ? (
                    <CaretUpOutline color="white" height="3rem" width="5rem" />
                ) : (
                    <CaretDownOutline
                        color="white"
                        height="3rem"
                        width="5rem"
                    />
                )}
            </div>
        </section>
    );
}
